var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntersect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60317 1.33333C1.89841 1.33333 1.33333 1.89841 1.33333 2.60317V9.5873C1.33333 10.2921 1.89841 10.8571 2.60317 10.8571H5.14286V13.3968C5.14286 14.1016 5.70794 14.6667 6.4127 14.6667H13.3968C14.1016 14.6667 14.6667 14.1016 14.6667 13.3968V6.41269C14.6667 5.70793 14.1016 5.14285 13.3968 5.14285H10.8571V2.60317C10.8571 1.89841 10.2921 1.33333 9.5873 1.33333H2.60317ZM2.60317 2.60317H9.5873V6.41269H13.3968V13.3968H6.4127V9.5873H2.60317V2.60317Z",
    fill: "#1F1F1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33333,
    y: 5.33333,
    width: 5.33333,
    height: 5.33333,
    rx: 1,
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/Intersect.bd953bed17b8ca32ecfc7057b6969478.svg";
export { ForwardRef as ReactComponent };